export default __webpack_public_path__ + "static/media/bkg--team-1.86428d3c.jpg";